import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router";
import ProgressBar from "../ProgreesBar/ProgressBar";
import { QuestionBlock } from "./styled";
import { Container, Heading, Text } from "../../styled";
import Radio from "../design_components/Radio/Radio";
import Checkbox from "../design_components/Checkbox/Checkbox";
import Button from "../design_components/Button/Button";
import {
  createEventObjectFunction,
  fadeInFunction,
  fadeOutFunction,
} from "../../utils/helper";
import { onboardingFillEventAmplitude } from "../../amplitude/events";
import { onboardingFillEvent } from "../../firebaseAnalytics/events";
import { analytics } from "../../firebaseAnalytics";

const Question = ({
  data,
  type,
  noteAnswer,
  currentRoute,
  answers,
  setAudioValue,
  landingId,
}) => {
  const [activeRadio, setActiveRadio] = useState(null);
  const [activeCheckBoxes, setActiveCheckBoxes] = useState([]);

  const history = useHistory();
  const location = useLocation();
  const animatedHeader = useRef(null);
  const animatedQuestions = useRef(null);

  const answerOnTypeRender = (type) => {
    switch (type) {
      case 1:
        return radioRender();
      case 4:
        return checkboxRender();
      case 8:
        return imageRender();
    }
  };

  useEffect(() => {
    fadeInFunction();
  }, [data, type]);

  useEffect(() => {
    setActiveRadio(null);
    setActiveCheckBoxes([]);
  }, [currentRoute]);

  const setQuestion = () => {
    if (currentRoute === "/onboarding/AboutYouRoutine") {
      return data.questions[answers[data.dependOn[0]]][
        answers[data.dependOn[1]]
      ];
    } else {
      return data.question;
    }
  };

  const handleCheckBoxClick = (index) => {
    const activeIndex = activeCheckBoxes.indexOf(index);
    if (activeIndex !== -1) {
      let newArr = activeCheckBoxes;
      newArr.splice(activeIndex, 1);
      setActiveCheckBoxes([...newArr]);
    } else {
      setActiveCheckBoxes([...activeCheckBoxes, index]);
    }
  };

  const handleCheckboxNextClick = () => {
    noteAnswer(currentRoute, activeCheckBoxes);
    fadeOutFunction();
    let advPropertyObj = {};
    if (data.advEventProperty) {
      advPropertyObj[data.advEventProperty] = data.answers[activeRadio].text;
    }
    const eventObj = createEventObjectFunction(
      data.eventFillName,
      null,
      landingId,
      advPropertyObj
    );
    // Событие №4 fill
    onboardingFillEvent(analytics, eventObj);
    onboardingFillEventAmplitude(eventObj);
    setTimeout(() => {
      history.push(data.nextRoute);
    }, 500);
  };

  const fadeOutAdded = () => {};

  const fadeInAdded = () => {};

  const radioRender = () => {
    return data.answers.map((answer, index) => {
      return (
        <QuestionBlock.Answer key={`answer-${index}`}>
          <Radio
            text={answer.text}
            index={index}
            value={answer.value}
            setActiveRadio={setActiveRadio}
            isActive={index === activeRadio}
            nextRoute={data.nextRoute}
            currentRoute={currentRoute}
            noteAnswer={noteAnswer}
            fadeOutAdded={fadeOutAdded}
            fadeInAdded={fadeInAdded}
            eventFillName={data.eventFillName}
            landingId={landingId}
            advEventProperty={data.advEventProperty}
          />
        </QuestionBlock.Answer>
      );
    });
  };

  const checkboxRender = () => {
    return data.answers.map((answer, index) => {
      return (
        <QuestionBlock.Answer key={`answer-${index}`}>
          <Checkbox
            text={answer.text}
            index={index}
            value={answer.value}
            activeCheckBoxes={activeCheckBoxes}
            setActiveFunction={() => handleCheckBoxClick(index)}
            isActive={activeCheckBoxes.find((checkbox) => checkbox === index)}
          />
        </QuestionBlock.Answer>
      );
    });
  };

  const imageRender = () => {
    return (
      <QuestionBlock.Images>
        {data.answers.map((answer, index) => {
          return (
            <QuestionBlock.Images.Item
              onClick={() => handleImgClick(index, answer.value)}
            >
              <QuestionBlock.Images.Picture.Wrapper
                isActive={index === activeRadio}
              >
                <QuestionBlock.Images.Picture>
                  <img src={answer.img} alt={answer.value} />
                </QuestionBlock.Images.Picture>
              </QuestionBlock.Images.Picture.Wrapper>
              <QuestionBlock.Images.Text>
                <Text.Second>{answer.text}</Text.Second>
              </QuestionBlock.Images.Text>
            </QuestionBlock.Images.Item>
          );
        })}
      </QuestionBlock.Images>
    );
  };

  const renderButtonBlock = () => {
    if (type === 4 && activeCheckBoxes.length) {
      return (
        <Button
          text={"Next"}
          isGradient={true}
          type={"default"}
          action={handleCheckboxNextClick}
        />
      );
    }
  };

  const handleImgClick = (index, value) => {
    setAudioValue(data.audioIndex, value);
    setActiveRadio(index);
    noteAnswer(currentRoute, [value]);
    // fadeOutFunction();
    const eventObj = createEventObjectFunction(
      data.eventFillName,
      null,
      landingId
    );
    // Событие №4 fill
    onboardingFillEvent(analytics, eventObj);
    onboardingFillEventAmplitude(eventObj);
    setTimeout(() => {
      // fadeInFunction();
      setActiveRadio(null);
    }, 200);
    setTimeout(() => {
      // fadeInFunction();
      history.push(data.nextRoute);
    }, 300);
  };

  return (
    <QuestionBlock>
      <Container.Content>
        <QuestionBlock.Wrapper>
          <QuestionBlock.Top>
            {!data.withOutProgress && (
              <QuestionBlock.Progress>
                <ProgressBar
                  currentBlock={data.questionBlock}
                  currentQuestion={data.questionNum}
                  totalQuestion={data.totalQuestion}
                />
              </QuestionBlock.Progress>
            )}

            <QuestionBlock.Title
              type={type}
              className={"animated"}
              ref={animatedHeader}
            >
              <Heading.Third>{setQuestion()}</Heading.Third>
              {data.title && (
                <QuestionBlock.Title.Add>
                  <Heading.Fourth>{data.title}</Heading.Fourth>
                </QuestionBlock.Title.Add>
              )}
              {data.text && (
                <div style={{ marginTop: 7 }}>
                  <Text.Fourth>{data.text}</Text.Fourth>
                </div>
              )}
            </QuestionBlock.Title>
            <QuestionBlock.Answers
              className={"animated"}
              ref={animatedQuestions}
            >
              {answerOnTypeRender(type)}
            </QuestionBlock.Answers>
          </QuestionBlock.Top>
          <QuestionBlock.Bottom>
            <QuestionBlock.Button>{renderButtonBlock()}</QuestionBlock.Button>
          </QuestionBlock.Bottom>
        </QuestionBlock.Wrapper>
      </Container.Content>
    </QuestionBlock>
  );
};

export default Question;
